<template>

  <div>
    <edit-applicant-address :value="address_history.address" :prefixLabel="prefixLabel"/>

    <div class="md-layout input-layout">

      <!-- Duration Years -->
      <validated-input
        type="DURATION_YEARS"
        class="md-layout-item md-small-size-100 md-size-10"
        v-if="duration"
        label="Years" v-model="address_history.duration.years"
        :prefixLabel="prefixLabel"
        :required="isYearRequired"
      />

      <!-- Duration Months -->
      <validated-input
        type="DURATION_MONTHS"
        class="md-layout-item md-small-size-100 md-size-10"
        v-if="duration"
        label="Months" v-model="address_history.duration.months"
        :prefixLabel="prefixLabel"
        :required="isMonthRequired"
      />

      <!-- Ownership -->
      <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-20"
        v-if="ownership"
        label="Ownership" v-model="address_history.ownership"
        :prefixLabel="prefixLabel"
        :options="options.address_history_ownership_options"
        force
      />

      <!-- Rent Amount -->
      <validated-input
        type="CURRENCY"
        class="md-layout-item md-small-size-100 md-size-20"
        v-if="ownership && is_address_rent_like"
        label="Rent"
        :prefixLabel="prefixLabel"
        prefix="$"
        v-model="address_history.expense.amount"
        :suffix="toMonthlyAmount(address_history.expense.amount, address_history.expense.frequency, true) + '/m'"
      />

      <!-- Frequency -->
      <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-20"
        v-if="ownership && is_address_rent_like"
        label="Frequency" v-model="address_history.expense.frequency"
        :prefixLabel="prefixLabel"
        :options="options.payment_frequency_options"
        force
      />

    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import ValidatedInputs from '@/components/ValidatedInput';
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import { isAddressRentLike } from "@/components/utils/validation";
import EditApplicantAddress from './EditApplicantAddress.vue';

export default {
  components: {
    ...ValidatedInputs,
    ListItemCard,
    EditApplicantAddress,
  },
  data(){
    return {
      search: {
        // query: '',
        status: false,
        results: [],
        queryer: null,
      },
      isMonthRequired: false,
      isYearRequired: false,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    duration: {
      type: Boolean,
      default: false,
    },
    ownership: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
      application: 'application',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    address_history: {
      get(){return this.value; },
      set(address_history){ this.$emit('input', address_history); },
    },

    is_address_rent_like(){ return isAddressRentLike(this.address_history); },
  },
  watch: {
    value: {
      handler(){
        this.$emit('change', this.value);
      },
      deep: true,
    },
    "address_history.ownership"() {
      if (!this.is_address_rent_like) {
        this.address_history.expense.amount = 0;
        this.address_history.expense.frequency = 'Weekly';
      }
    },
    "address_history.duration.years"(newVal) {
      this.isMonthRequired = newVal !== null && this.address_history.duration.months === null;
      this.isYearRequired = newVal === null && this.address_history.duration.months !== null;
    },
    "address_history.duration.months"(newVal) {
      this.isMonthRequired = newVal === null && this.address_history.duration.years !== null;
      this.isYearRequired = newVal !== null && this.address_history.duration.years === null;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'address_history_ownership_options',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
